var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"topbar"},[_c('a',{on:{"click":_vm.goback}},[_vm._v("返回上一頁")])])}
var staticRenderFns = []

export { render, staticRenderFns }